// Inlined from css-in-js-utils/lib/isPrefixedValue (MIT, Robin Frischmann) so the
// prefixer has no runtime dependencies. See VENDORED.md.

var regex = /-webkit-|-moz-|-ms-/;

export default function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
